var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "python"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74.956 0C36.6227 0 39.0162 16.5998 39.0162 16.5998L39.0587 33.7977H75.6395V38.9609H24.5295C24.5295 38.9609 0 36.183 0 74.8056C0 113.429 21.4099 112.06 21.4099 112.06H34.1873V94.1367C34.1873 94.1367 33.4984 72.7574 55.2554 72.7574H91.537C91.537 72.7574 111.921 73.0863 111.921 53.0851V20.0142C111.921 20.0142 115.017 0 74.956 0ZM54.7854 11.5652C55.6498 11.5645 56.5059 11.7339 57.3047 12.0639C58.1034 12.3938 58.8292 12.8779 59.4405 13.4882C60.0517 14.0986 60.5364 14.8233 60.8669 15.621C61.1973 16.4186 61.367 17.2735 61.3662 18.1367C61.367 18.9998 61.1973 19.8547 60.8669 20.6524C60.5364 21.45 60.0517 22.1747 59.4405 22.7851C58.8292 23.3955 58.1034 23.8795 57.3047 24.2094C56.5059 24.5394 55.6498 24.7089 54.7854 24.7081C53.9209 24.7089 53.0648 24.5394 52.2661 24.2094C51.4673 23.8795 50.7415 23.3955 50.1303 22.7851C49.519 22.1747 49.0343 21.45 48.7039 20.6524C48.3734 19.8547 48.2037 18.9998 48.2045 18.1367C48.2037 17.2735 48.3734 16.4186 48.7039 15.621C49.0343 14.8233 49.519 14.0986 50.1303 13.4882C50.7415 12.8779 51.4673 12.3938 52.2661 12.0639C53.0648 11.7339 53.9209 11.5645 54.7854 11.5652V11.5652Z",
    fill: "url(#paint0_linear_225_151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M76.0446 150C114.378 150 111.984 133.4 111.984 133.4L111.942 116.203H75.3604V111.04H126.47C126.47 111.04 151 113.817 151 75.1936C151 36.5703 129.59 37.9401 129.59 37.9401H116.813V55.8625C116.813 55.8625 117.501 77.2418 95.7445 77.2418H59.4629C59.4629 77.2418 39.0789 76.9129 39.0789 96.9147V129.986C39.0789 129.986 35.9836 150 76.044 150H76.0446ZM96.2152 138.436C95.3507 138.437 94.4946 138.267 93.6959 137.937C92.8971 137.607 92.1713 137.123 91.5601 136.513C90.9488 135.902 90.4641 135.178 90.1337 134.38C89.8032 133.582 89.6335 132.728 89.6343 131.864C89.6335 131.001 89.8031 130.146 90.1335 129.349C90.4639 128.551 90.9486 127.826 91.5599 127.216C92.1711 126.605 92.8969 126.121 93.6957 125.791C94.4945 125.461 95.3507 125.292 96.2152 125.292C97.0796 125.292 97.9357 125.461 98.7345 125.791C99.5332 126.121 100.259 126.605 100.87 127.215C101.481 127.826 101.966 128.55 102.297 129.348C102.627 130.146 102.797 131.001 102.796 131.864C102.797 132.727 102.627 133.582 102.297 134.379C101.966 135.177 101.481 135.902 100.87 136.512C100.259 137.123 99.5332 137.607 98.7345 137.937C97.9357 138.267 97.0796 138.436 96.2152 138.435V138.436Z",
    fill: "url(#paint1_linear_225_151)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_225_151",
    x1: 14.511,
    y1: 13.4916,
    x2: 89.2359,
    y2: 87.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_225_151",
    x1: 60.4423,
    y1: 60.9961,
    x2: 140.694,
    y2: 136.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.6918e844cdb9595e3acd07aa7fa46b7d.svg";
export { ForwardRef as ReactComponent };